var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { CreateAppointmentParticipantDto } from './create-appointment-participant.dto.js';
/**
 * One appointment in a plan-free batch (ADR-0004). Mirrors CreateAppointmentDto's
 * per-appointment fields but without participants (shared at the batch level) and
 * without any TreatmentPlan / billableServiceItem linkage.
 */
export class CreateAppointmentBatchSlotDto {
    scheduledStart;
    plannedDuration;
    treatmentLocation;
    therapistId;
    roomId = null;
    deviceIds = [];
    officeLocationId;
    service = null;
    description = null;
}
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CreateAppointmentBatchSlotDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateAppointmentBatchSlotDto.prototype, "plannedDuration", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    __metadata("design:type", String)
], CreateAppointmentBatchSlotDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentBatchSlotDto.prototype, "therapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentBatchSlotDto.prototype, "roomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateAppointmentBatchSlotDto.prototype, "deviceIds", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentBatchSlotDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentBatchSlotDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentBatchSlotDto.prototype, "description", void 0);
/**
 * Create multiple plain appointments at fixed times with no TreatmentPlan link
 * (ADR-0004) — the batch analogue of POST /appointments. Used by the slot finder
 * when booking without a Verordnung (Selbstzahler / ad-hoc). Participants are shared
 * across all slots.
 */
export class CreateAppointmentsBatchDto {
    slots;
    participants = [];
}
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentBatchSlotDto),
    __metadata("design:type", Array)
], CreateAppointmentsBatchDto.prototype, "slots", void 0);
__decorate([
    IsArray(),
    ArrayMaxSize(5),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentParticipantDto),
    __metadata("design:type", Array)
], CreateAppointmentsBatchDto.prototype, "participants", void 0);
//# sourceMappingURL=create-appointments-batch.dto.js.map